import apiAxios from "helpers/apiAxios";

// Everything about who gets paid — replaced together when the vendor changes.
export const VENDOR_PAYMENT_FIELDS = ["recipient_name", "bank_account", "bank_name", "bank_bic", "bank_clearing_code",
  "recipient_street", "recipient_building", "recipient_postcode", "recipient_town", "recipient_country"];

// The AX vendor picked on the Vendor line → the payment details it gives (bank name /
// account, BIC, bank code, address). Read only — Save keeps them.
// => { erp_vendor: { account, name, bank_name, bank_account, bank_code, bank_bic, address }, payment: {...},
//      sources: { recipient_name, bank_account, bank_name, bank_bic, bank_clearing_code, address } }
export const fetchVendorDetails = (requestId, account) =>
  apiAxios.get(`/erp/payment_requests/${requestId}/vendor_details`, { params: { account } }).then((r) => r.data.data);
